var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pagesTotal > 1 && _vm.loading === false)?_c('v-row',{staticClass:"mt-5 mb-5 text-center"},[_c('v-pagination',{staticClass:"mt-5 mb-5",attrs:{"value":_vm.value,"total-visible":"7","length":_vm.pagesTotal},on:{"input":_vm.updatePage}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }